import React from "react";
import { AppId, FCX, ProductLogo, sanitize, usePlatformContext } from "@datassential/platform-ui-lib";
import './ReadAboutIt.scss';
import cn from "classnames";
import Widget from "@components/Widget/Widget";
import PublicationCard, { PublicationCardTooltip } from "@components/PublicationCard/PublicationCard";
import { useMenuPublications } from "@apiHooks/useMenuPublications";

const REPORT_PRO_TAG_ID = 14;

const ReadAboutIt: FCX = ({
    className,
    testId,
    style,
}) => {
    const {
        data: reports,
        isLoading,
    } = useMenuPublications();

    const {
        userInfo: {
            products,
            reportProDetailsUrl,
        },
    } = usePlatformContext();
    const productRP = products[AppId.ReportPro];
    const detailsPath = process.env.REACT_APP_RP_ITEM_LINK ?? reportProDetailsUrl;

    return (
        <Widget
            className={cn(
                "ReadAboutIt",
                className,
                isLoading && "ReadAboutIt--loading"
            )}
            style={style}
            headerContent={(
                <div className="ReadAboutIt__header">
                    <div className="ReadAboutIt__header-title">
                        READ ABOUT IT:
                    </div>
                    {!isLoading && (
                        <a
                            className="ReadAboutIt__view-more appears"
                            target="_blank"
                            rel="noreferrer"
                            href={sanitize(`${productRP.url}/?tags=${REPORT_PRO_TAG_ID}`)}
                            data-testid={`buttonMacReportsItemViewMore`}
                        >View all reports</a>
                    )}
                </div>
            )}
            testId={testId}
        >
            <div className={cn("ReadAboutIt__content", isLoading && "ReadAboutIt__content--loading")}>
                {isLoading && (
                    <div className="TrendingNow__spinner">
                        <ProductLogo appId={AppId.Snap} type="regular"/>
                    </div>
                )}
                {!isLoading && reports.slice(0, 4).map((report, index) => (
                    <React.Fragment key={report.id}>
                        <PublicationCard
                            className="ReadAboutIt__card"
                            data={report}
                            index={index}
                            link={`${productRP.url}${detailsPath}${report.id}`}
                            tooltipId={`macs-reports-item-${report.id}`}
                            testIdBase="MacsReportsItem"
                        />
                        <PublicationCardTooltip
                            className={"ReadAboutIt__card-tooltip"}
                            data={report}
                            index={index}
                            tooltipId={`macs-reports-item-${report.id}`}
                            testIdBase="MacsReportsItem"
                        />
                    </React.Fragment>
                ))}
            </div>
        </Widget>
    );
};

export default ReadAboutIt;
